import SelectedTrainerOverlay from './SelectedTrainerOverlay.jsx';

export default SelectedTrainerOverlay;
